import axios from "axios";

const isProduction = process.env.NODE_ENV === "production";

const BASE_URL_DEV  = process.env.REACT_APP_API_DEV || '';
const BASE_URL_PROD = process.env.REACT_APP_API_LOCAL || '';
const BASE_URL      = isProduction ? BASE_URL_PROD : BASE_URL_DEV;

if (!BASE_URL) {
    console.error('URL da API não configurada');
}

const CLIENT = process.env.REACT_APP_ALIAS_EMPRESA || '';

const handleError = (error) => {
    try {
        const errorResponse = error?.response?.data;
        
        // Se já estiver no formato padronizado, retorna diretamente
        if (errorResponse?.statusCode && errorResponse?.error) {
            console.error('[API Error]:', errorResponse.error);
            return Promise.reject(errorResponse?.error?.description);
        }

        // Caso contrário, formata o erro no padrão esperado
        const formattedError = errorResponse || error?.message || 'Erro desconhecido'
        

        console.error('[API Error]:', formattedError);
        return Promise.reject(formattedError);
    } catch (e) {
        console.error('[API Error Handler]:', e);
        return Promise.reject({
            statusCode: 500,
            error: {
                type: 'INTERNAL_ERROR',
                description: 'Erro ao processar resposta do servidor'
            }
        });
    }
};

const api_local = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        accept: "application/json",
    },
    responseType: "json",
});

api_local.isProduction = isProduction;

// Interceptor para adicionar token nas requisições
api_local.interceptors.request.use(
    function (config) {
        
        const token = sessionStorage.getItem("agendamento_web_token");

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        config.headers["client"] = CLIENT;

        return config;
    },
    handleError
);

// Interceptor para processar respostas
api_local.interceptors.response.use(
    function (response) {
        return response.data || {};
    },
    handleError
);

export default api_local;
